import React, { Component } from 'react';
import { connect } from 'react-redux';
import { login } from '../../ducks/auth';
import { NavLink } from 'react-router-dom';
import { getProfile, userSelector } from '../../ducks/users';
import { Redirect } from 'react-router-dom';
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import { AwesomeButtonProgress } from "react-awesome-button"
import "react-awesome-button/dist/styles.css";
import InputField from '../../components/atom/InputField';
import LoginImg from '../../assets/loading-login.svg';
import Gamepad from '../../assets/Gamepad';
import setPageTitle from '../../components/atom/PageTitle'


const mapStateToProps = (store, { match: { params } }) => {
  return {
    me: !!store.users.me,
    profile: userSelector(store, get(store, ['users', 'me'])),
  }
}

class Login extends Component {

  constructor(props) {
    super(props);

    this.events = {
      handleChange: this._handleChange.bind(this),
      handleLogin: debounce(this._handleLogin.bind(this), 300),
      handleSubmit: this._handleSubmit.bind(this),
    }

    this.state = {
      email: '',
      password: '',
      loadingLogin: false,
      loginError: false,
      fakePress: false,
    };
  }

  _handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  _handleSubmit(event) {
    event.preventDefault();
    this.setState({ fakePress: !this.state.fakePress }, () => {
      this.setState({ fakePress: !this.state.fakePress})
    })
  }

  _handleLogin(element, next) {
    const { dispatch } = this.props;
    //reset animation
    this.setState({ loadingLogin: true })

    dispatch(login(this.state.email, this.state.password))
    .then(res => {
      dispatch(getProfile())
    })
    .catch(err => {
      this.setState({ loginError: true, loadingLogin: false })
      next(false, 'Fel :(')
    })
    next()
  }

  render() {
    if (this.props.me) return <Redirect to="/" />;

    let errorMsg;
    if (this.state.loginError) {
      errorMsg = 'Fel email eller lösenord';
    }

    setPageTitle('Logga in')

    return (
      <div className="Login-container">
        <div className="Login-column Login-first">
          <div>
            <h1>Logga in</h1>
            Välkommen in tillbaka äventyrare. Glöm inte att ta en vända vid
            baren för att plocka upp ett par potions. Se också till att hålla
            dig ifrån trubbel i byn!
          </div>
          <img src={LoginImg} alt="" width="190" height="190" />
        </div>
        <form onSubmit={this.events.handleSubmit}>
          <InputField
            label="EMAIL"
            errorMsg={errorMsg}
            type="email"
            name="email"
            value={this.state.email}
            onChange={this.events.handleChange}
          />
          <InputField
            label="LÖSENORD"
            errorMsg=""
            type="password"
            name="password"
            value={this.state.password}
            onChange={this.events.handleChange}
          />
          <div className="Login-column" style={{paddingTop: '18px'}}>
            <AwesomeButtonProgress
              fakePress={this.state.fakePress}
              type="primary"
              loadingLabel="Loading"
              onPress={(element, next) => this.events.handleLogin(element, next)}
            >
              <Gamepad
                style={{ position: 'relative', height: '17px', top: '4px', marginRight: '3px' }}
                color="white"
              />{' '}
              Logga in
            </AwesomeButtonProgress>
            <NavLink to="/reset" className="Reset-link">
              Glömt lösenordet?
            </NavLink>
          </div>
        </form>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Login);

// <input placeholder="Länk till omslagsbild" type="date" name="publicationDate" value={this.state.publicationDate} onChange={this.events.handleChange} />